import * as loader from "../../../../components/file-loader/utils/utils";
import { apiFetch } from "../../../../services/api-fetch";
import { getMediaUrl } from "../../../../services/helpers/get-media-url";
import Toast from "../../../../components/modal/toast";
import { triggerEvent } from "../../../../services/helpers/trigger-event";

const initBrandLoader = () => {
  let loadButton = document.querySelector('[data-brand-load]');
  let brand = document.querySelector('.brand');

  if (!loadButton || !brand) return;

  let loadAction = loadButton.dataset.brandLoad;

  loadButton.addEventListener("click", () => {
    

    loader.selectFiles()
      .then(res => {
        triggerEvent(document.body, "remove.modal");

        let file = res.files[0];
        let data = new FormData();
        data.append('image', file);
        data.append('tokenWallpaper', loadButton.dataset.token);

        apiFetch(loadAction, {
          method: "POST",
          body: data
        }).then(res => {
          if (res.success) {
            brand.style.backgroundImage = `url(${getMediaUrl(res.file.url)})`;
          } else {
            Toast.open(res.error, { state: "error" });
          }
        }).catch(err => {
          console.error(err);
          Toast.open("Не удалось загрузить изображение", { state: "error" });
        })
      })
  })
}

export { initBrandLoader };